export class PrimaryChatMetadata {
  useInternet: boolean;
  companyNames: string[];
  sources: string[];
  isPlaybook: boolean;

  constructor(response: any) {
    this.useInternet = response.useInternet;
    this.companyNames = response.companyNames;
    this.sources = response.sources;
    this.isPlaybook = response.isPlaybook;
  }
}
